// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import StockGql from '@/extensions/shop/store/graphql/queries/Stock.gql';
import StocksGql from '@/extensions/shop/store/graphql/queries/Stocks.gql';
import CreateStockGql from '@/extensions/shop/store/graphql/mutations/CreateStock.gql';
import UpdateStockGql from '@/extensions/shop/store/graphql/mutations/UpdateStock.gql';
import DeleteStockGql from '@/extensions/shop/store/graphql/mutations/DeleteStock.gql';
import StocksPaginatedGql from '@/extensions/shop/store/graphql/queries/StocksPaginated.gql'

export default {
    fetchList: (shopID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: StocksGql,
                    variables,
                })
                .then(({ data }) => resolve(data.CO_Stocks))
                .catch((err) => reject(err));
        }),
    // fetchStocksPaginated: data => new Promise((resolve, reject) => {
    fetchStocksPaginated: (data, shopID) => new Promise((resolve, reject) => {
        let filters = []
        _.each(data.filters, entry => filters.push(entry))

        apolloClient.query({
            query: StocksPaginatedGql,
            variables: {
                currentPage: _.get(data, 'pageInfo.currentPage', 1),
                perPage: _.get(data, 'pageInfo.perPage', 25),
                order: _.get(data, 'variables.order', 'id'),
                direction: _.get(data, 'variables.direction', 'asc'),
                shop: parseInt(shopID),
                filters
            }
        })
            .then(({ data }) => resolve(data.CO_StocksPaginated))
            .catch(err => reject(err))
    }),
    fetchStock: (stockId) => new Promise((resolve, reject) => {
        let filters = []
        // _.each(data.filters, entry => filters.push(entry))

        apolloClient.query({
            query: StockGql,
            variables: {
                id: parseInt(stockId)
            }
        })
            .then(({ data }) => resolve(data.CO_Stock))
            .catch(err => reject(err))
    }),
    fetchStocks: () => new Promise((resolve, reject) => {
        // let filters = []
        // _.each(data.filters, entry => filters.push(entry))

        apolloClient.query({
            query: StocksGql,
            // variables: {
            //     id: parseInt(stockId)
            // }
        })
            .then(({ data }) => resolve(data.CO_Stocks))
            .catch(err => reject(err))
    }),
    create: stock => {
        if (stock === undefined) throw new Error('required argument is missing')

        stock = _.removeDeepByKey(stock, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: CreateStockGql,
                variables: { stock }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_CreateStock)
                })
                .catch(err => reject(err))
        })
    },
    update: stock => {
        if (stock === undefined) throw new Error('required argument is missing')

        stock = _.removeDeepByKey(stock, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: UpdateStockGql,
                variables: { stock }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_UpdateStock)
                })
                .catch(err => reject(err))
        })
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing')

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: DeleteStockGql,
                variables: { id }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_DeleteStock)
                })
                .catch(err => reject(err))
        })
    }
};
